import {ReduceStore} from 'flux/utils';
import {Filters} from '../../constants/filter/filters';

export class SizeConfiguratorFilterOptionsStoreClass extends ReduceStore {
    getInitialState() {
        const filterOptions = [
            Filters.WIDTH,
            Filters.HEIGHT,
            Filters.DIAMETER,
            Filters.SPEED_INDEX,
            Filters.LOAD_INDEX,
        ];
        return this.initFilterOptions(filterOptions);
    }

    initFilterOptions(filters) {
        const initialSizeConfiguratorFilterStoreState = {};

        filters.forEach(filter => {
            initialSizeConfiguratorFilterStoreState[filter] = [];
        });

        return initialSizeConfiguratorFilterStoreState;
    }

}
